"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailHelper = /** @class */ (function () {
    function EmailHelper() {
    }
    EmailHelper.openEmailClient = function (subject, body, recipient) {
        var href = "mailto:";
        if (recipient != null) {
            href += recipient;
        }
        href += "?";
        if (subject != null) {
            href += "subject=" + subject;
        }
        if (subject != null && body != null) {
            href += "&";
        }
        href += "body=" + body;
        window.location.href = href;
    };
    return EmailHelper;
}());
exports.default = EmailHelper;
//# sourceMappingURL=emailHelper.js.map


/** WEBPACK FOOTER **
 ** ./src/utils/emailHelper.js
 **/